import 'firebase/auth'
import 'firebase/database'

import firebase from 'firebase/app'
import React, { useContext, useState } from 'react'

firebase.initializeApp({
  apiKey: 'AIzaSyAKuGrRgWfnX2rupWcop5x0chazelDwReM',
  authDomain: 'shopify-payment-gateways.firebaseapp.com',
  databaseURL: 'https://shopify-payment-gateways.firebaseio.com',
  projectId: 'shopify-payment-gateways',
})

interface IProps {
  rootPath?: string
}

interface IContextProps {
  auth: firebase.auth.Auth
  ref: (path: string) => firebase.database.Reference
}

const context = React.createContext<IContextProps | null>(null)

export const Firebase: React.FC<IProps> = ({ rootPath = '/', children }) => {
  const [rootRef] = useState(() => firebase.database().ref(rootPath))
  const props: IContextProps = {
    auth: firebase.auth(),
    ref: path => rootRef.child(path),
  }
  return <context.Provider value={props}>{children}</context.Provider>
}

export function useFirebase() {
  return useContext(context)!
}
